import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { refresh } from './TokenService';

const auth = axios.create({
  baseURL: import.meta.env.VITE_AUTH_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

auth.interceptors.request.use(
  async (config) => {
    const { ...newConfig } = config;
    let token = localStorage.getItem('accessToken');
    if (token && token.substring(0, 2) === 'ey') {
      let decoded;
      try {
        decoded = jwtDecode(token);
        // eslint-disable-next-line no-unused-vars
      } catch (e) {
        decoded = null;
      }
      const exp = decoded?.exp;
      if (exp * 1000 < Date.now() + 2000) {
        const refreshToken = localStorage.getItem('refreshToken');
        const decodedRefresh = jwtDecode(refreshToken);
        const expRefresh = decodedRefresh?.exp;
        if (expRefresh * 1000 < Date.now()) {
          localStorage.clear();
          window.location.reload();
        }
        await refresh();
        token = localStorage.getItem('accessToken');
      }
    }
    if (token) {
      newConfig.headers.Authorization = `Bearer ${token}`;
    }
    return newConfig;
  },
  (error) => Promise.reject(error),
);

export default auth;
